<template>
	<div>
		<div class="produto">
			<Imagens :imagens="imagens" :galeria="false" :desconto="retornarDesconto(this.precos)" />
			<div class="produto__info">
				<div class="produto__descricao">
					{{ this.item.descricao }}
				</div>
				<div class="produto__precos">
					<div class="produto__preco produto__preco--anterior" v-if="this.precos.percpromocao > 0">
						{{
							convertDinheiro(
								calculaDesconto(
									this.precos.precodinheiro,
									this.precos.percpromocao,
									this.precos.promoqtapartirde
								)
							)
						}}
					</div>
					<div class="produto__preco">
						{{ valorItem }}
					</div>
				</div>
			</div>
			<Botao
				:texto="desabilitarBotao() ? 'Esgotado ' : 'Comprar'"
				@clicar="comprar()"
				:disabled="desabilitarBotao()"
			/>
			<ImagemDialog :dialog="dialog" :imgSrc="imgSrc" @dialogClose="dialogClose" />
		</div>
	</div>
</template>
<script>
import ImagemDialog from './ImagemDialog.vue'
import Imagens from '../shared/Imagens.vue'
import Botao from '../shared/Botao.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
	props: {
		item: {},
	},
	components: {
		ImagemDialog,
		Imagens,
		Botao,
	},
	data: function () {
		return {
			computador: {
				cliente: {},
			},
			imgSrc: '',
			dialog: false,
			dialogQuantidade: false,
			loading: false,
			precos: this.item.precos[0],
			variacoes: this.item.variacoes,
			quantidade: 0,
			quantidadesSelector: ['1', '2', '3', '4', '5'],
			dialogComprarCategorizado: false,
			dialogComprarSku: false,
		}
	},
	computed: {
		...mapGetters({ empresa: 'empresa', catalogo: 'catalogo' }),
		valorItem() {
			var vlTotItem =
				this.calculaDesconto(
					this.precos.precodinheiro,
					this.precos.percpromocao,
					this.precos.promoqtapartirde,
					1
				) * 1
			return this.convertDinheiro(vlTotItem)
		},
		imagens() {
			if (this.item.imagens.length > 0) return this.item.imagens
			else return [{ url_img: require(`@/assets/produto.png`) }]
		},
	},
	methods: {
		...mapActions(['addcadastroProduto']),
		imagemSelected(img) {
			this.dialog = true
			this.imgSrc = img
		},
		comprar() {
			this.addcadastroProduto(this.item)
			this.$router.push(
				`/${this.catalogo.identificadorCatalogo}/${this.item.codigo}/${this.item.descricao.replace(/[^\w\s]/gi, '').replaceAll(' ', '-')}${this.retornarQueryVendedor()}`
			)
		},
		desabilitarBotao() {
			return this.verificarProdutoEsgotado(this.item.codigo, this.item.estoque)
		},
		dialogQuantidadeOpen() {
			this.dialogQuantidade = true
		},
		dialogClose() {
			this.imgSrc = ''
			this.dialog = false
		},
		dialogQuantidadeClose() {
			this.dialogQuantidade = false
		},
		dialogComprarCategorizadoOpen() {
			this.dialogComprarCategorizado = true
		},
		dialogComprarCategorizadoClose() {
			this.dialogComprarCategorizado = false
		},
		dialogComprarSkuOpen() {
			this.dialogComprarSku = true
		},
		dialogComprarSkuClose() {
			this.dialogComprarSku = false
		},
		formatarNumero(numero) {
			return numero.replace('.', ',').replace(',00', '')
		},
		...mapActions(['addToCart']),
	},
	mounted() {
		let imagens = []
		if (this.item.sku && this.item.imagens.length < 1) {
			this.item.skus.map((sku) => {
				if (sku.skuimagens.length > 0) {
					imagens.push({ url_img: sku.skuimagens[0].url_img })
				}
			})

			this.item.imagens = imagens.filter(
				(value, index, self) => self.map((x) => x.url_img).indexOf(value.url_img) == index
			)
		}
	},
}
</script>

<style scoped>
.produto {
	width: 250px;
	min-height: 380px;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 2rem;
	display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.produto__info {
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
}

.produto__descricao {
	font-weight: 900;
	font-size: 16px;
	color: var(--v-texto-base);
	text-transform: uppercase;
}

.produto__precos {
	display: flex;
	gap: 1rem;
}

.produto__preco {
	font-weight: bold;
	font-size: 16px;
	color: var(--v-primary-base);
}

.produto__preco--anterior {
	color: var(--v-textoPrecoAntigo-base);
	text-decoration: line-through;
}
</style>

